import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { P1 } from '../../../../components/Typographies/Paragraph';
import { H2 } from '../../../../components/Typographies/Title';
import Line from '../../../../images/illustrations/line.svg';
import ImageTexture from '../../../../images/textures/texture.png';
import { homePageDestinationsMessages } from './messages';
import { Slider, SliderControl } from './Slider';

const Container = styled.div`
  ${tw`relative py-big px-medium2 rounded-30 flex flex-col
    md:px-huge2 md:py-huge md:mt-huge
  `}
  background:url(${ImageTexture}),linear-gradient(97.78deg, #F5F4EC 0.37%, #EDFDF9 92.55%);
  gap: var(--size-big);
`;

const Content = styled.div`
  ${tw`flex flex-col  lg:flex-row `}
  shrink:0;
  gap: var(--size-big);
`;

const Description = styled.div`
  ${tw`w-full flex-no-shrink`}
  max-width:395px;
`;

const Title = styled(H2)`
  ${tw`mb-big`}
`;

const Image = styled.img`
  ${tw`hidden md:block absolute`}
  bottom: 0;
  left: -116px;
  bottom: -32px;
`;

const Banner = () => {
  const swiperRef = useRef();
  const [currentSlideIndex, setCurrentSlideIndex] = useState<number>(0);
  return (
    <Container>
      <Content>
        <Description>
          <Title>
            <FormattedMessage
              {...homePageDestinationsMessages.destinationsBannerTitle}
            />
          </Title>
          <P1>
            <FormattedMessage
              {...homePageDestinationsMessages.destinationsBannerSubTitle}
            />
          </P1>
        </Description>

        <Slider
          setCurrentSlideIndex={setCurrentSlideIndex}
          swiperRef={swiperRef}
        />
      </Content>

      <SliderControl currentIndex={currentSlideIndex} swiperRef={swiperRef} />

      <Image alt="Green line" src={Line} />
    </Container>
  );
};

export default Banner;
